import React, { useReducer, useContext, useRef, useEffect, useMemo } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import Tooltip from 'rc-tooltip';
import Tool_circulatingTab from '../../Components/Tools/Tool_circulatingTab';
import Tool_CusFilter from '../../Components/Tools/Tool_CusFilter';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { FormattedMessage } from 'react-intl';
import { Global } from '../../App';
import { AsyncModel, AsyncModelClose } from '../../Components/AsyncModel/AsyncModel';
import { CusButton } from '../../Components/From/Button';
import StoreSelector from '../../Components/From/StoreSelector';
import ReactLoading from 'react-loading';
import _ from 'lodash';
import cls from 'classnames'
import '../../Pages/pages.scss';
// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';
// api
import { getAllProduct, getTagList } from '../../Api/GetProduct';
import { getAllStore } from '../../Api/GetStore';

import defaultImg from '../../Resource/image/icons/img_no_image.png';
import ScrollTabs from '../../Components/Common/ScrollTabs'

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE_STATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

function ShowMenu(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    currentCategory: null,
    toggleToolTips: false,
    storeMenuStore: null,
    searchInput: '',
    getApi: [],
    categoryList: [], // tab
    filterCategoryList: [],
    mealList: [], // meals
    tagList: {}, //tags
    tagSelected: [],
    veganSelected:[],
    tagPopupToggle: false,
    branchList: []
  });
  const _menuListRef = useRef([]);
  let _isEnabledScroll = useRef(true);
  let _isEnabledSlick = useRef(true);
  let _scrollRef = useRef(null);
  let _sliderRef = useRef(null);

  function handleScroll() {
    if (_isEnabledScroll.current) {
      _isEnabledSlick.current = false;
      const { _container: scrollContainer } = _scrollRef.current; // scrollArea
      // 當前整體高度 沒有超過scrollArea dom的index
      const firstEleIndex = _menuListRef.current.findIndex(ele => {
        return ele.offsetTop + ele.offsetHeight > scrollContainer.scrollTop;
      });
      // console.log(li[firstEleIndex], state.currentCategory, _menuListRef.current[firstEleIndex])
      if (state.mealList[firstEleIndex].type !== state.currentCategory.type) {
        console.log('set slick index');
        const goToIndex = state.categoryList.findIndex(
          item => item.type === state.mealList[firstEleIndex].type
        );
        _sliderRef.slickGoTo(goToIndex, true);
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'currentCategory', val: state.categoryList[goToIndex] }
          ]
        });
      }
      setTimeout(() => {
        _isEnabledSlick.current = true;
      }, 0);
    } else {
      console.log('onSelecteding');
    }
  }
  async function apiAllProduct(langId, storeId) {
    try {
      const waittingAlert = AsyncModel({
        content: (
          <div className="w-100 d-flex justify-content-center">
            <ReactLoading
              type="spokes"
              color="#ccc"
              height="100px"
              width="100px"
            />
          </div>
        ),
        showConfirmBtn: false
      });
      const res = await getAllProduct(langId, storeId);
      AsyncModelClose();
      const { errCode, productList } = res.data;
      if (errCode == 200) {
        // 分類tabs
        let _categoryList = [];
        // let _categoryList = productList.map(e => ({
        //   title: e.name,
        //   type: e.id
        // }));
        // 餐點總攬
        let _mealList = productList.map(e => {
          let type = e.id;
          let typeName = e.name;
          // 分類同時push進去
          _categoryList.push({
            title: e.name,
            type
          });
          let newArr = e.product.map(_product => ({
            type: type,
            typeName: typeName,
            title: _product.name,
            description: _product.description,
            ..._product
          }));
          return newArr;
        });
        _mealList = _.flatten(_mealList);
        return { _categoryList, _mealList };
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.push('/error');
      }
    } catch (err) {
      console.error('Product error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 407 }]
      });
      props.history.push('/error');
    }
  }

  async function apiGetTagList(langId) {
    try {
      const res = await getTagList(langId);
      const { errCode, tagList } = res.data;
      if (errCode == 200) {
        return tagList;
      } else {
        console.error('GetTagList error.', errCode);
      }
    } catch (err) {
      console.error('GetTagList error.');
    }
  }

  // 取得所有分店
  async function apiAllStore(langId) {
    try {
      let res = await getAllStore(langId);
      const { errCode, branch } = res.data;
      if (errCode == 200) {
        let newList = branch.map(e => ({
          branchName: e.name,
          branchCode: e.id,
          openTime: e.openTime,
          closeTime: e.closeTime
        }));
        console.log(newList);
        let menuStore = null;
        if (state.storeMenuStore) {
          const findStore = branch.find(f => (state.storeMenuStore.branchCode === f.id));
          // if (state.storeMenuStore.branchName !== findStore.name) {
          //   dispatchGlobal({
          //     type: 'UPDATE',
          //     payload: [
          //       {
          //         key: 'customer',
          //         val: {
          //           ...globalState.customer,
          //           orderInfo: {
          //             ...globalState.customer.orderInfo,
          //             selectedBranch: findStore
          //           }
          //         }
          //       }
          //     ]
          //   });
          // }
          menuStore = {
            branchName: findStore.name,
            branchCode: findStore.id,
            openTime: findStore.openTime,
            closeTime: findStore.closeTime
          };
        }
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'branchList', val: newList },
            { key: 'storeMenuStore', val: globalState.customer.orderInfo.selectedBranch || menuStore || null }
          ]
        });

        // 清空來店資訊已重置語系
        if (globalState.customer.orderInfo.selectedBranch) {
          dispatchGlobal({
            type: 'UPDATE',
            payload: [
              {
                key: 'customer',
                val: {
                  ...globalState.customer,
                  orderInfo: {
                    ...globalState.customer.orderInfo,
                    selectedBranch: null
                  }
                }
              }
            ]
          });
        }
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errCode', val: errCode }]
        });
        props.history.push('/error');
      }
    } catch (err) {
      console.error('AllStore error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errCode', val: 404 }]
      });
      props.history.push('/error');
    }
  }

  // 選擇分店
  const showBranchOption = useMemo(() => {
    return (
      <PerfectScrollbar className="col p-0">
        <div className="w-100 h-100 clearfix">
          {state.branchList.map((i, index) => (
            <CusButton
              key={index}
              className="Pages__branch p-3 store"
              onClick={() => {
                dispatch({
                  type: 'UPDATE_STATE',
                  payload: [
                    { key: 'storeMenuStore', val: i }
                  ]
                });
              }}
              children={i.branchName}
            />
          ))}
        </div>
      </PerfectScrollbar>
    );
  }, [
    globalState.customer.orderInfo.selectedBranch,
    state.branchList
  ]);

  // call api
  useEffect(() => {
    const langCode = langStringToCode(globalState.langType);
    apiAllStore(langCode);
  }, [globalState.langType]);

  // get api
  useEffect(() => {
    if (state.storeMenuStore) {
      const langCode = langStringToCode(globalState.langType);
      async function handler() {
        const getProduct = await apiAllProduct(langCode, state.storeMenuStore.branchCode);
        const tagList = await apiGetTagList(langCode);

        if (getProduct && tagList) {
          dispatchGlobal({
            type: 'UPDATE',
            payload: [
              {
                key: 'staffInfo',
                val: {
                  ...globalState.staffInfo,
                  allergenTags: tagList.allergenMenu.concat(tagList.allergenMenu).map(m => (m.id)),                
                  veganTags: tagList.vegetarian
                }
              }
            ]
          });
          dispatch({
            type: 'UPDATE_STATE',
            payload: [
              { key: 'categoryList', val: getProduct._categoryList },
              { key: 'mealList', val: getProduct._mealList },
              { key: 'tagList', val: tagList },
              {
                key: 'currentCategory',
                val: state.currentCategory || getProduct._categoryList[0]
              }
            ]
          });
        }
      }
      handler();
    }
  }, [
    globalState.langType,
    state.storeMenuStore
  ]);

  // 檢查是否有店別
  useEffect(() => {
    const handle = async () => {
      let {
        selectedBranch
      } = globalState.customer.orderInfo;
      if (selectedBranch) {
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'storeMenuStore', val: selectedBranch }
          ]
        });
      } else {
        dispatch({
          type: 'UPDATE_STATE',
          payload: [
            { key: 'storeMenuStore', val: null }
          ]
        });
      }
    };
    handle();
  }, []);

  const $tabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      let filterArray = [];
      // 有輸入關鍵字
      if (state.searchInput || state.tagSelected || state.veganSelected) {
        // 找出有該關鍵字的分類type
        let t = state.mealList
        // 關鍵字篩選
        .filter(f => {
          const target = state.searchInput;

          return (
            f.searchNum.toString().indexOf(target) > -1 ||
            f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
          );
        })
        // 標籤篩選
        .filter(f => {
          // 沒有全選標籤時
          if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length) {                
            // 有篩選條件
            if (globalState.staffInfo.filterTag.length) {
              return globalState.staffInfo.filterTag.every(i => (
                f.allergenMenu.map(m => (m.id)).includes(i)
              ))
            } else {
              return f.allergenMenu.length === 0;
            }
          } else {
            return true;
          }
        })
        .filter(f => {
          if(globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length &&
            globalState.staffInfo.filterVegan.length !== state.tagList.vegetarian.length) {
              if(globalState.staffInfo.filterVegan.length){
                return globalState.staffInfo.filterVegan.some(i => (
                  f.vegetarian.map(m=> (m.id)).includes(i)
                ))
              } else {
                return f.vegetarian.length === 0;
              }
          } else {
            return true;
          }            
        });

        filterArray = [...new Set(t.map(item => (item.type)))];

        // 轉換回文字
        const filterTabs = state.categoryList
          .filter(({ type: id1 }) =>
            filterArray.some((id2) =>
              id2 === id1
            ));

        // 有結果
        if (filterTabs.length) {
          let result = filterTabs.map(item => ({
            title: item.title,
            value: item.type,
            count: (filterTabs.length === state.categoryList.length) ? 0 : t.filter(cnt => { return cnt.type === item.type}).length
          }));

          dispatch({
            type: 'UPDATE_STATE',
            payload: [
              { key: 'filterCategoryList', val: result },
            ]
          });

          return result 
        } else {
          // 查無結果，顯示全分類
          return state.categoryList.map(item => ({
            title: item.title,
            value: item.type,
            count: 0
          }))
        }
      } else {
        if(state.filterCategoryList !== undefined){
          return state.filterCategoryList.map(item => ({
            title: item.title,
            value: item.type,
            count: (state.filterCategoryList.length == state.categoryList.length)? 0 : item.count
          })) 
        } 

        return state.categoryList.map(item => ({
          title: item.title,
          value: item.type,
          count: 0
        }))
      }
    }
    return []
  }, [state.categoryList, state.searchInput, state.tagSelected, state.veganSelected])

  const $allTabs = useMemo(() => {
    if (state.categoryList !== undefined) {
      return state.categoryList.map(item => ({
        title: item.title,
        value: item.type
      }))
    }
    return []
  }, [state.categoryList])

  const $tabItems = useMemo(() => {
    if (state.mealList !== undefined) {
      if (state.searchInput || (state.tagSelected && state.tagSelected.length > 0) || (state.veganSelected && state.veganSelected.length > 0)) {
        // 輸入關鍵字移動到上方
        const { y } = document.getElementsByClassName('ScrollTabs')[0].getBoundingClientRect()
        document.body.scrollTo({
          top: document.body.scrollTop + y,
          behavior: 'smooth'
        })

        return state.mealList
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.every(i => (
                  f.allergenMenu.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.allergenMenu.length === 0;
              }
            } else {
              return true;
            }
          })
          .filter(f => {
            if(globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length &&
              globalState.staffInfo.filterVegan.length !== state.tagList.vegetarian.length) {
                if(globalState.staffInfo.filterVegan.length){
                  return globalState.staffInfo.filterVegan.some(i => (
                    f.vegetarian.map(m=> (m.id)).includes(i)
                  ))
                } else {
                  return f.vegetarian.length === 0;
                }
            } else {
              return true;
            }            
          })
          // 關鍵字篩選
          .filter(f => {
            // if (state.searchInput) {
            const target = state.searchInput;
            return (
              f.searchNum.toString().indexOf(target) > -1 ||
              f.name.toLowerCase().indexOf(target.toLowerCase()) > -1
            );
            // } else {
            //   return [];
            // }
          })
          .map(item => ({
            $tab: item.type,
            ...item
          }))
      } else {
        let t = state.mealList
          // 標籤篩選
          .filter(f => {
            // 沒有全選標籤時
            if (globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length) {
              // 有篩選條件
              if (globalState.staffInfo.filterTag.length) {
                return globalState.staffInfo.filterTag.some(i => (
                  f.allergenMenu.map(m => (m.id)).includes(i)
                ))
              } else {
                return f.allergenMenu.length === 0;
              }
            } else {
              return true;
            }
          })
          .filter(f => {
            if(globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length &&
              globalState.staffInfo.filterVegan.length !== state.tagList.vegetarian.length) {
                if(globalState.staffInfo.filterVegan.length){
                  return globalState.staffInfo.filterVegan.some(i => (
                    f.vegetarian.map(m=> (m.id)).includes(i)
                  ))
                } else {
                  return f.vegetarian.length === 0;
                }
            } else {
              return true;
            }            
          })
          .map(item => ({
            $tab: item.type,
            ...item
          }));

          return t;
      }
    }
    return []
  }, [state.mealList, state.searchInput, state.tagSelected, state.veganSelected])
  return (
    <div className="Pages">
      <Header />
      <div className="TakeOrder col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0">
        <div className="Pages__section d-flex flex-column align-items-center pb-sm-4">
          <div className="Pages__title d-flex">
            <FormattedMessage
              id="pages.showMenu.title"
              children={e => {
                const splitString = e.split('');
                const { langType } = globalState;
                if (langType !== 'zh' && langType !== 'ja' && langType !== 'ko') {
                  const splitString = e.split(' ');
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                } else {
                  const splitString = e.split('');
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                }
              }}
            />
          </div>
        </div>
        {
          state.storeMenuStore ? (
            <>
              <StoreSelector
                mode="pc"
                options={state.branchList}
                defaultOption={state.storeMenuStore.branchName}
                // onToggle={() => {
                //   setState(fp.set('isOpenLang', !state.isOpenLang))
                // }}
                onSelect={(e) => {
                  dispatch({
                    type: 'UPDATE_STATE',
                    payload: [
                      { key: 'storeMenuStore', val: e }
                    ]
                  });
                }}
              />
              <div className="Pages__section d-flex flex-column col p-0">
                <div className="Pages__section d-flex flex-column col p-0">
                  <FormattedMessage
                    id="pages.showMenu.searchMenuInputPlaceholder"
                    children={msg => {
                      return (
                        <ScrollTabs
                          tabs={$tabs}
                          allTabs={$allTabs}
                          items={$tabItems}
                          searchPlaceholder={msg}
                          menuType={globalState.staffInfo.menuType}
                          isFillFilter={(globalState.staffInfo.filterTag && globalState.staffInfo.filterTag.length > 0) || (globalState.staffInfo.filterVegan && globalState.staffInfo.filterVegan.length > 0)}
                          itemOnSelected={() => {
                            dispatch({
                              type: 'UPDATE_STATE',
                              payload: [
                                { key: 'searchInput', val: '' }
                              ]
                            });
                          }}
                          openFilter={() => {
                            dispatch({
                              type: 'UPDATE_STATE',
                              payload: [
                                { key: 'tagPopupToggle', val: true }
                              ]
                            });
                          }}
                          searchOnChange={(val) => {
                            dispatch({
                              type: 'UPDATE_STATE',
                              payload: [
                                { key: 'searchInput', val: val }
                              ]
                            });
                          }}
                          menuTypeSwitch={() => {
                            dispatchGlobal({
                              type: 'UPDATE',
                              payload: [
                                {
                                  key: 'staffInfo',
                                  val: {
                                    ...globalState.staffInfo,
                                    menuType: globalState.staffInfo.menuType === 1 ? 2 : 1
                                  }
                                }
                              ]
                            });
                          }}
                          renderItem={(itemInfo, index) => (
                            <div
                              key={index}
                              className={cls('Pages__meals pt-2 pt-sm-4 pb-2 pb-sm-4',
                                itemInfo.product_status === 3 ? ' isSoldOut' : '',
                                globalState.staffInfo.menuType === 1 ? 'isRwd' : ''
                              )}
                              ref={ref => {
                                if (
                                  ref &&
                                  _menuListRef.current.filter(e => e === ref) < 1
                                ) {
                                  _menuListRef.current.push(ref);
                                }
                              }}
                              onClick={() => {
                                dispatchGlobal({
                                  type: 'UPDATE',
                                  payload: [
                                    {
                                      key: 'customer',
                                      val: {
                                        ...globalState.customer,
                                        currentStep: '3.1',
                                        mealDetail: itemInfo,
                                        isFromOrderDetail: false
                                      }
                                    }
                                  ]
                                });
                              }}
                            >
                              <div className="Pages__meals__imgBoxBlock d-flex">
                                <div className="Pages__meals__imgBox">
                                  <img
                                    src={itemInfo.img ? itemInfo.img : defaultImg}
                                    alt=""
                                  />
                                </div>
                                <div className={cls("Pages__meals__info d-flex flex-column flex-sm-row",
                                  globalState.staffInfo.menuType === 1 ? '' : 'col justify-content-center justify-content-sm-start align-items-sm-center',
                                  globalState.langType
                                )}>
                                  <div className="d-flex flex-column col-sm p-0">
                                    <span className="Pages__meals__title mt-1 mb-1 mt-sm-2 mb-sm-2">
                                      {itemInfo.title}
                                    </span>
                                    <div className="Pages__meals__icon d-flex flex-wrap mt-1 mb-1 mt-sm-2 mb-sm-2">
                                      {itemInfo.recommend.map((recommendInfo, index) => (
                                        <Tooltip
                                          key={index}
                                          placement="bottom"
                                          trigger={['hover', 'click']}
                                          overlay={
                                            <span children={recommendInfo.description} />
                                          }
                                        >
                                          <img
                                            style={{ height: '25px' }}
                                            className="mr-1 mb-1"
                                            src={recommendInfo.icon}
                                            onClick={e => {
                                              e.stopPropagation();
                                            }}
                                            alt=""
                                          />
                                        </Tooltip>
                                      ))}
                                    </div>
                                    {
                                      globalState.staffInfo.menuType === 1 ? (
                                        <div className="d-flex mx-auto">
                                          <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-inline-block d-sm-none">
                                            $ {itemInfo.price}
                                          </span>
                                          {
                                            itemInfo.product_status === 3 ? (
                                              <span className="mt-1 mb-1 ml-2 mr-sm-2 mt-sm-2 mb-sm-2">
                                                <FormattedMessage id="pages.showMenu.soldOut" />
                                              </span>
                                            ) : null
                                          }
                                          <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-sm-inline-block d-none">
                                            $ {itemInfo.price}
                                          </span>
                                        </div>
                                      ) : null
                                    }
                                  </div>
                                  {
                                    globalState.staffInfo.menuType === 1 ? null : (
                                      <div className="d-flex justify-content-sm-end">
                                        <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-inline-block d-sm-none">
                                          $ {itemInfo.price}
                                        </span>
                                        {
                                          itemInfo.product_status === 3 ? (
                                            <span className="mt-1 mb-1 ml-2 mr-sm-2 mt-sm-2 mb-sm-2">
                                              <FormattedMessage id="pages.showMenu.soldOut" />
                                            </span>
                                          ) : null
                                        }
                                        <span className="mt-1 mb-1 mt-sm-2 mb-sm-2 d-sm-inline-block d-none">
                                          $ {itemInfo.price}
                                        </span>
                                      </div>
                                    )
                                  }
                                </div>
                              </div>
                            </div>
                          )}
                        />
                      )
                    }}
                  />
                  {/* <Tool_circulatingTab
              onRef={e => (_sliderRef = e)}
              currentCategory={state.currentCategory}
              items={state.categoryList}
              onSelected={e => {
                console.log(e);
                if (_isEnabledSlick.current) {
                  _isEnabledScroll.current = false;
                  const { type } = e; // 當前分類
                  const firstItemIdx = state.mealList.findIndex(
                    item => item.type === type
                  ); // 當前分類的第一個dom的index
                  const ele = _menuListRef.current[firstItemIdx]; // 當前分類的第一個dom
                  const { _container: scrollContainer } = _scrollRef.current; // scrollArea
                  const isOutTop = ele.offsetTop < scrollContainer.scrollTop; // 當前分類的第一個dom位置是否小於當前scrollTop顯示的位置(prev btn)
                  const isOutDown = ele.offsetTop > scrollContainer.scrollTop; // 當前分類的第一個dom位置是否大於當前scrollTop顯示的位置(next btn)
                  // if (isOutTop || isOutDown) {
                  //   console.log('isOutTop : '+isOutTop, 'isOutDown : '+isOutDown);
                  scrollContainer.scrollTop = ele.offsetTop;
                  // }
                  dispatch({
                    type: 'UPDATE_STATE',
                    payload: [{ key: 'currentCategory', val: e }]
                  });
                  setTimeout(() => {
                    _isEnabledScroll.current = true;
                  }, 0);
                }
              }}
            />
            <div
              className="d-flex flex-column col p-0"
              style={{
                flex: '1 1 0'
              }}
            >
              <PerfectScrollbar
                style={{
                  // maxHeight: 'calc(100vh - 55px - 78px - 58px - 52px - 36px)'
                  flex: '1 1 0'
                }}
                ref={_scrollRef}
                onScrollUp={ref => handleScroll('prev')}
                onScrollDown={ref => handleScroll('next')}
              >
                {state.mealList.map((itemInfo, index) => (
                  <div
                    key={index}
                    className="Pages__meals pt-2 pb-2 pt-sm-4 pb-sm-4"
                    ref={ref => {
                      if (
                        ref &&
                        _menuListRef.current.filter(e => e === ref) < 1
                      ) {
                        _menuListRef.current.push(ref);
                      }
                    }}
                    onClick={() => {
                      dispatchGlobal({
                        type: 'UPDATE',
                        payload: [
                          {
                            key: 'customer',
                            val: {
                              ...globalState.customer,
                              currentStep: '3.1',
                              mealDetail: itemInfo,
                              isFromOrderDetail: false
                            }
                          }
                        ]
                      });
                    }}
                  >
                    <div className="d-flex">
                      <div className="Pages__meals__imgBox">
                        <img
                          src={itemInfo.img ? itemInfo.img : defaultImg}
                          alt=""
                        />
                        {(() => {
                          let findProduct = globalState.customer.mealOrderDetail.find(
                            f => f.id === itemInfo.id
                          );
                          if (findProduct) {
                            let productQuantity = findProduct.specification.reduce(
                              (currSpec, itemSpec) => {
                                return (
                                  currSpec +
                                  itemSpec.combination.reduce(
                                    (currCombi, itemCombi) => {
                                      return currCombi + itemCombi.quantity;
                                    },
                                    0
                                  )
                                );
                              },
                              0
                            );
                            return (
                              <div className="Pages__meals__notes d-flex justify-content-center align-items-center">
                                <span>{productQuantity}</span>
                              </div>
                            );
                          } else {
                            // return null
                          }
                        })()}
                      </div>
                      <div className="Pages__meals__info d-flex flex-column flex-sm-row col justify-content-center justify-content-sm-start align-items-sm-center">
                        <div className="d-flex flex-column col-sm p-0">
                          <span className="Pages__meals__title mt-1 mb-1 mt-sm-2 mb-sm-2">
                            {itemInfo.title}
                          </span>
                          <div className="d-flex flex-wrap mt-1 mb-1 mt-sm-2 mb-sm-2">
                            {itemInfo.allergen.map((allergenInfo, index) => (
                              <Tooltip
                                key={index}
                                placement="bottom"
                                overlay={
                                  <span children={allergenInfo.description} />
                                }
                              >
                                <img
                                  style={{ height: '30px' }}
                                  className="mr-1 mb-1"
                                  src={allergenInfo.icon}
                                  alt=""
                                />
                              </Tooltip>
                            ))}
                          </div>
                        </div>
                        <div className="d-flex justify-content-sm-end">
                          <span className="mt-1 mb-1 mt-sm-2 mb-sm-2">
                            $ {itemInfo.price}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </PerfectScrollbar>
            </div> */}
                </div>
              </div>
            </>
          ) : (
            <div className="d-flex col flex-column mt-3 mb-3 p-0">
              <>
                {showBranchOption}
              </>
            </div>
          )
        }
      </div>
      <Footer />
      {/* 標籤篩選視窗 */}
      {(() => {
        if (!state.tagPopupToggle) return null;
        return (
          <Tool_CusFilter
            tagGroup={state.tagList}
            selectedItems={globalState.staffInfo.filterTag}
            selectedVeganItems ={globalState.staffInfo.filterVegan}
            onClose={() => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [
                  { key: 'tagPopupToggle', val: false }
                ]
              });
            }}
            onSelectItem={tagIds => {
              dispatch({
                type: 'UPDATE_STATE',
                payload: [
                  { key: 'tagSelected', val: tagIds.allergen },
                  { key: 'veganSelected', val: tagIds.vegan }
                ]
              });
              dispatchGlobal({
                type: 'UPDATE',
                payload: [
                  {
                    key: 'staffInfo',
                    val: {
                      ...globalState.staffInfo,
                      filterTag: tagIds.allergen,
                      filterVegan: tagIds.vegan,
                    }
                  }
                ]
              });
            }}
          />
        );
      })()}
    </div>
  );
}

export default ShowMenu;
